"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTableUI = void 0;
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
var TreeFilterAndOrder_1 = require("../TreeFilterAndOrder");
/**
 * @deprecated
 * Use `createTableUIStatefulColumns`
 */
var createTableUI = function (props) {
    var columnsRenderMap = props.columnsRenderMap, actionsRender = props.actionsRender, tableColumnsTreeFilterAndOrderProps = props.tableColumnsTreeFilterAndOrderProps;
    var TableUI = function (_a) {
        var filterAndOrderColumns = _a.filterAndOrderColumns, on = _a.on, rest = __rest(_a, ["filterAndOrderColumns", "on"]);
        var columns = __spreadArray([], filterAndOrderColumns.map(function (key) { return (__assign(__assign({}, columnsRenderMap[key]), { dataIndex: key })); }));
        if (actionsRender) {
            columns.push({
                title: "",
                render: actionsRender === null || actionsRender === void 0 ? void 0 : actionsRender({ on: on }),
                fixed: "right",
            });
        }
        return (react_1.default.createElement(antd_1.Table, __assign({ size: "small" }, rest, { columns: columns, pagination: __assign(__assign({}, rest.pagination), { showQuickJumper: true }) })));
    };
    var renderColumnAllKeys = Object.keys(columnsRenderMap);
    var filterAndOrderCols = renderColumnAllKeys.reduce(function (acc, key) {
        var _a;
        var val = columnsRenderMap[key];
        return __assign(__assign({}, acc), (_a = {}, _a[key] = {
            title: val.title,
            key: key,
        }, _a));
    }, {});
    var useColumnsFilter = function () {
        return TreeFilterAndOrder_1.useTreeFilterAndOrder(__assign({ columns: filterAndOrderCols }, tableColumnsTreeFilterAndOrderProps));
    };
    return {
        useColumnsFilter: useColumnsFilter,
        TableUI: TableUI,
    };
};
exports.createTableUI = createTableUI;
